import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';

import { extension } from 'mime-types';
import moment from 'moment';
import {
  axiosBarwisSecureInstance,
  axiosBarwisInstance
} from 'libs/axios/axios.lib';
import layoutStore from 'stores/layout.store';
import barwisFileStore from 'stores/barwis-file.store';

export const getUserRoleDisplayName = (role) => {
  let displayName = '';
  switch (role) {
    case 4:
      displayName = 'External Coach';
      break;
    case 'athlete':
      displayName = 'Athlete';
      break;
    case 'Athlete':
      displayName = 'Athlete';
      break;
    case 5:
      displayName = 'Athlete';
      break;
    case 'client':
      displayName = 'Client';
      break;
    case 'Client':
      displayName = 'Client';
      break;
    case 6:
      displayName = 'Client';
      break;
    default:
      displayName = role;
  }

  return displayName;
};

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isObject = (value) => {
  return !!value && value.constructor === Object;
};

export const isValidUrl = (url) => {
  let valid;
  try {
    valid = new URL(url);
  } catch (error) {
    valid = false;
  }
  return !!valid;
};

export const getUrlFromPath = (path) => {
  const publicStorageUrl = process.env.REACT_APP_PUBLIC_STORAGE_URL;
  let finalUrl = '';
  if (isValidUrl(path)) {
    finalUrl = path;
  } else {
    finalUrl = `${publicStorageUrl}/${path}`;
  }
  return finalUrl;
};

export const removeSpecialChars = (str) => {
  return str.replace(/[^a-zA-Z0-9]/g, '_');
};

export const getPrivateFile = async (path, name) => {
  try {
    const platform = layoutStore.getPlatform();
    barwisFileStore.setIsFileLoading(true);
    if (platform === 'mobile') {
      const fileResponse = await axiosBarwisSecureInstance.get(
        `/file/${path}`,
        {
          responseType: 'blob'
        }
      );
      const fileExtension = extension(fileResponse.data.type);
      const cleanedName = removeSpecialChars(name);
      const filename = `${cleanedName}.${fileExtension}`;
      const fileWriteResponse = await File.writeFile(
        File.dataDirectory,
        filename,
        fileResponse.data,
        {
          replace: true
        }
      );
      barwisFileStore.setIsFileLoading(false);
      await FileOpener.showOpenWithDialog(
        `${File.dataDirectory}${filename}`,
        fileResponse.data.type
      );
    } else {
      const fileResponse = await axiosBarwisInstance.get(`/file/${path}`, {
        responseType: 'blob'
      });
      const fileExtension = extension(fileResponse.data.type);
      const filename = `${name}.${fileExtension}`;
      const downloadRef = layoutStore.getDownloadRef();
      const url = URL.createObjectURL(fileResponse.data);
      downloadRef.current.href = url;
      downloadRef.current.download = filename;
      barwisFileStore.setIsFileLoading(false);
      downloadRef.current.click();
    }
  } catch (error) {
    layoutStore.setToastConfig({
      message: error.message ? error.message : `Error loading file`,
      color: 'danger'
    });
    barwisFileStore.setIsFileLoading(false);
  }
};

export const getFileExtension = (path) => {
  const extension = path.split('.').reverse();
  return extension[0];
};

export const trimString = (str, maxLength = 120) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + '...';
  }
  return str;
};

export const getDayAndRepetitionNo = (workoutAssignment, selectedDate) => {
  const start_date = moment(workoutAssignment.start_date, 'YYYY-MM-DD');
  const total_days = workoutAssignment.workout.workoutTotalDays;
  const cur_diff = selectedDate?.diff(start_date, 'days') + 1;
  let curDay;
  let repetition_no = Math.ceil(cur_diff / total_days);
  if (cur_diff > total_days) {
    curDay = cur_diff % total_days;
    if (!curDay) {
      curDay = total_days;
    }
  } else {
    curDay = cur_diff;
  }
  return {
    day: curDay,
    repetition_no: repetition_no
  };
};

export const getAppVersion = () => {
  const version = '0.1.44';
  return version;
};
